<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3z7w6F/images/9781439647585.jpg?1688985070624" alt="This image is the cover for the book Legendary Locals of Denton, Legendary Locals"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Legendary Locals of Denton, Legendary Locals
      </h1>
      <p class="bookDescription body article font2">
        <p>Denton, Texas, was founded in 1857 because residents needed a location near the geographic center of Denton County to house a county seat. The city is located 39 miles north of two larger cities, Dallas and Fort Worth, and the three of them form what is often referred to as the �Golden Triangle.� Denton, the peak of that triangle, is the �North Star,� and its residents, past and present, certainly are superstars�superstars such as Bob Rogers, the beloved �Piano Man;� Mary Evelyn Blagg Huey, a quintessential leader; and Hal Jackson, an ace war hero and lawyer. Their accomplishments burst forth from the chapters of this book to outshine others with their generosity, talents, skills, community activism, adventurous spirits, energy, civic pride, business acumen, courage, and creativity. Citizens of Denton are proud to say, �Our history defines our community.� The images and words between these covers illustrate why it should be added, �And our people define our history.�</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dr. Georgia Caraway
      </h2>
      
      <p class="authorDescription body article">Dr. Georgia Caraway is the coauthor of three titles from Arcadia Publishing, Images of America: Denton, Images of America: Denton County, and Then & Now: Denton. She is also the author of Tips, Tools & Techniques for Caring for Your Antiques & Collectibles. She retired after 14 years as the executive director of the Denton County Museums and is now promoting her books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?39bb7fc0